"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddCatalogueOfferErrorResponse = exports.Name = exports.AddCatalogueOfferFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'add-catalogue-offer-failed';
const AddCatalogueOfferFailedEvent = exports.AddCatalogueOfferFailedEvent = Name;
const isAddCatalogueOfferErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAddCatalogueOfferErrorResponse = isAddCatalogueOfferErrorResponse;
